import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Auth APIs
// ──────────────────────────────────────────────

/**
 * Login with credentials
 * @param {{ email: string, password: string }} credentials
 */
export const loginApi = (credentials) =>
  axiosInstance.post('/login', credentials).then((res) => res.data); // Removed /api prefix as it's base URL and matched api.js

/**
 * Send signup code
 * @param {{ email: string }} data
 */
export const sendSignupCodeApi = (data) =>
  axiosInstance.post('/register/send-code', data).then((res) => res.data);

/**
 * Verify signup code
 * @param {{ email: string, code: string }} data
 */
export const verifySignupCodeApi = (data) =>
  axiosInstance.post('/register/verify-code/web', data).then((res) => res.data);

/**
 * Register a new user
 * @param {FormData} userData
 */
export const registerApi = (userData) =>
  axiosInstance.post('/register/web', userData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => res.data);

/**
 * Forgot password - request OTP
 * @param {{ email: string }} data
 */
export const forgotPasswordApi = (data) =>
  axiosInstance.post('/forgot-password/web', data).then((res) => res.data);

/**
 * Verify OTP for password reset
 * @param {{ email: string, otp: string }} data
 */
export const verifyOTPApi = (data) =>
  axiosInstance.post('/verify-otp/web', data).then((res) => res.data);

/**
 * Reset password
 * @param {{ email: string, otp: string, password: string }} data
 */
export const resetPasswordApi = (data) =>
  axiosInstance.post('/reset-password/web', data).then((res) => res.data);

/**
 * Fetch logged-in user profile
 */
export const getUserProfileApi = () =>
  axiosInstance.get('/profile').then((res) => res.data);

/**
 * Get all countries
 */
export const getAllCountriesApi = () =>
  axiosInstance.get('/country').then((res) => res.data);

/**
 * Get all timezones
 */
export const getTimeZonesApi = () =>
  axiosInstance.get('/timezones').then((res) => res.data);

/**
 * Login / Register with Google credentials
 * @param {{ displayName: string, email: string, id: string, photoUrl: string, user_type: string, time_zone?: string }} userData
 */
export const googleLoginApi = (userData) =>
  axiosInstance.post('/google-login', userData).then((res) => res.data);
